























import { defineComponent, ref } from '@vue/composition-api';

export default defineComponent({
  name: 'UserPassword',
  setup() {
    const password = ref<string>('');
    const confirmPassword = ref<string>('');

    const showPW = ref<boolean>(false);
    const showCPW = ref<boolean>(false);

    const passwordRules = [
      (val: string) => (!!val || 'Password required'),
      // eslint-disable-next-line no-mixed-operators
      (val: string) => (val && val.length >= 12 || 'Minimum 12 characters required'),
      // eslint-disable-next-line no-mixed-operators
      (val: string) => (val && val.match(/[\p{Lu}]/u) || 'Password must contain capital letters'),
      // eslint-disable-next-line no-mixed-operators
      (val: string) => (val && val.match(/[\p{Ll}]/u) || 'Password must contain lowercase letters'),
      // eslint-disable-next-line no-mixed-operators
      (val: string) => (val && val.match(/[\p{P}\p{S}]/u) || 'Password must contain a special character'),

    ];

    const confirmPasswordRules = [
      (val: string) => (!!val || 'Password confirmation required'),
      // eslint-disable-next-line no-mixed-operators
      (val: string) => (val && val === password.value || 'Password does not match'),
    ];

    return {
      password,
      confirmPassword,
      showPW,
      showCPW,
      passwordRules,
      confirmPasswordRules,

    };
  },
});

